<template>
  <div class="competition" @click.stop.prevent="gotoMatch(item)">
    <div class="imgBox">
      <img
        class="imgs"
        :src="
          language === 'zh'
            ? item.zhListImage
            : item.enListImage || item.zhListImage | imageUrl('', 1080, 608)
        "
        alt=""
      />
    </div>
    <div class="infoBox">
      <p class="title">
        {{ language === "zh" ? item.title : item.enTitle || item.title }}
      </p>
      <div class="nameBox">
        <p class="name" @click.stop.prevent="gotoPeople(item.userId)">
          <span class="headImg"
            ><img
              class="ava"
              :src="item.userAvatar | imageUrl('', 48, 48)"
              alt="" /></span
          >{{ item.userNickName }}
        </p>
        <p class="name" @click.stop.prevent="gotoPeople('3272934')" v-if="item.id == 1032">
          <span class="headImg"
            ><img
              class="ava"
              src="https://image.manamana.net/1642129624000_TsdxmBNA?imageView2/1/w/280/h/280/format/gif"
              alt="" /></span
          >安恒集团
        </p>
      </div>
      <p class="time">
        {{ timeStamp(item.deliverStartTime) }} {{ $t("global.至") }}
        {{ timeStamp(item.deliverEndTime) }}
      </p>
    </div>
    <p
      class="status"
      :class="{
        matchColor1:
          item.matchState == 1 ||
          item.matchState == 3 ||
          item.matchState == 4 ||
          item.matchState == 5,
        matchColor2: item.matchState == 2,
        matchColor3: item.matchState == 6,
      }"
    >
      {{ matchState(item.matchState) }}
    </p>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "competition",
  props: ["item"],
  data() {
    return {};
  },

  methods: {
    matchState(status) {
      if (status == 1) {
        return this.$t("live.即将开始");
      }
      if (status == 2) {
        return this.$t("global.投稿中");
      }
      if (status == 3) {
        return this.$t("global.评审中");
      }
      if (status == 4) {
        return this.$t("works.入围作品公布");
      }
      if (status == 5) {
        return this.$t("global.获奖作品公布");
      }
      if (status == 6) {
        return this.$t("global.已结束");
      }
    },
    gotoMatch(item) {
      if (item.type == 1) {
        let routeData = this.$router.resolve({
          path: "/match/" + item.url
        });
        window.open(routeData.href, "_blank");
      }
      if (item.type == 2) {
        window.open(item.url, "_blank");
      }
    },
    gotoPeople(id) {
      let routeData = this.$router.resolve({
        path: "/peopleCenter/" + id + "/home"
      });
      window.open(routeData.href, "_blank");
    }
  },
  computed: {
    language() {
      return this.$language();
    }
  },
  created() {}
};
</script>

<style lang="stylus" scoped>
.competition {
  width: 100%;
  height: 100%;
  cursor: pointer;
  position: relative;

  .imgBox {
    width: 100%;
    height: 304px;

    .imgs {
      width: 100%;
      height: 100%;
    }
  }

  .infoBox {
    width: 540px;

    .title {
      padding: 0 24px;
      min-height: 28px;
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      line-height: 28px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      word-break: break-word;
      margin: 16px 0 10px 0;

      &:hover {
        color: #0A0A0A;
      }
    }
    .nameBox{
      padding: 0 24px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    .name {
      display: inline-block;
      height: 24px;
      line-height: 24px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      margin-right: 20px;
      .headImg {
        margin-right: 6px;

        .ava {
          width: 24px;
          height: 24px;
          border-radius: 50%;
          vertical-align: bottom;
        }
      }
    }

    .time {
      padding: 0 24px;
      height: 21px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      line-height: 21px;
      margin: 12px 0 16px 0;
    }
  }

  .status {
    position: absolute;
    left: 0;
    bottom: 21px;
    padding: 0 24px;
    height: 28px;
    line-height: 28px;
    font-size: 13px;
    font-weight: 400;
    color: #ffffff;
  }

  .matchColor1 {
    background: linear-gradient(135deg, #3664ED 0%, #2026CC 100%);
  }

  .matchColor2 {
    background: linear-gradient(135deg, #FEA174 0%, #FE5630 100%);
  }

  .matchColor3 {
    background: linear-gradient(135deg, #CCCCCC 0%, #999999 100%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/activity/competition.vue